/* eslint-disable */
// @ts-nocheck
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { LOGOUT } from '@tgtg/core/auth/types';
import { sessionSelector } from '@tgtg/core/session';
import { CREATE_SESSION, INIT_SESSION, REVALIDATE_SESSION } from '@tgtg/core/session/types';

import { ampli } from '../ampli';
import { fromURL, PRODUCTION } from '../common/env/env';
import { startAppListening } from '../core/redux-store/listenerMiddleware';

export const amplitudeListeners = () => {
  startAppListening({
    type: INIT_SESSION.REQUEST,
    effect: async () => {
      await ampli.load({
        environment:
          fromURL(window.location) === PRODUCTION ? 'mycharityproduction' : 'mycharitydevelopment',
      });
      ampli.client.add(sessionReplayPlugin({ sampleRate: 0.1 }));
    },
  });

  startAppListening({
    predicate: (action) =>
      action.type === CREATE_SESSION?.SUCCESS || action.type === REVALIDATE_SESSION?.SUCCESS,
    effect: async (_action, listenerApi) => {
      const state = listenerApi.getState();
      const session = sessionSelector(state);

      if (session?.isAuthenticated) {
        const { userId } = session;
        ampli.client.setUserId(`${userId}`);
      }
    },
  });

  startAppListening({
    type: LOGOUT.SUCCESS,
    effect: async () => {
      await ampli.client.flush();
      ampli.client.reset();
    },
  });
};
